import React, { useState } from 'react';
import { Box, IconButton, Typography, Menu, MenuItem } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../Auth/AuthContext';
import ConfigDialog from './ConfigAdmin/ConfigDialog';
import axios from 'axios';
import { Backdrop, CircularProgress } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const ButtonsUser = ({ handleOpenUserMenu, handleCloseUserMenu, anchorElUser }) => {
  const { logout } = useAuth();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const areUserAdmin = user.rol === 'Administrador';

  const [openDialog, setOpenDialog] = useState(false);
  const [configData, setConfigData] = useState(null);

  const fetchConfig = async () => {
    try {
      const res = await axios.get(`${API_URL}/configuracion/`);
      setConfigData(res.data);
      return res.data;
    } catch (err) {
      console.error('Error cargando configuración:', err);
      throw err;
    }
  };

  const saveConfig = async (formData) => {
    setLoading(true);
    try {
      const response = await axios.put(`${API_URL}/configuracion/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setConfigData(response.data);
      return response.data;
    } catch (err) {
      console.error('Error guardando configuración:', err);
      throw new Error(err.response?.data?.logo?.[0] || 'No se pudo guardar la configuración.');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenConfig = async () => {
    handleCloseUserMenu();
    setLoading(true);
    try {
      await fetchConfig();
      setOpenDialog(true);
    } catch (err) {
      window.alert('No se pudo cargar la configuración.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexDirection: { xs: 'column', sm: 'row' }, // En XS se pone uno abajo del otro
        paddingLeft: 0,
        paddingRight: 0,
        gap: 1, // espacio entre ícono y texto
        flexWrap: 'wrap',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="subtitle1"
        noWrap
        sx={{
          color: 'white',
          maxWidth: { xs: '100%', sm: 200 },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: { xs: 'center', sm: 'right' },
        }}
      >
        {user.nombre} {user.rol}
      </Typography>

      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
        <AccountCircle sx={{ color: 'white' }} />
      </IconButton>
    </Box>

      <Backdrop
        open={loading}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ flexGrow: 0, paddingLeft: 3 }}>
        <Menu
          sx=
          {{
            mt: '45px'
          }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'top',             
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
            {areUserAdmin && <MenuItem onClick={handleOpenConfig}>
              <Typography sx={{ textAlign: 'center' }}>Configuración</Typography>
            </MenuItem>}
            <MenuItem onClick={() => {logout()}}>
              <Typography sx={{ textAlign: 'center' }}>Cerrar Sesión</Typography>
            </MenuItem>
          </Menu>
        </Box>

        <ConfigDialog
          open={openDialog}
          handleClose={() => setOpenDialog(false)}
          configData={configData}
          onSave={saveConfig}
        />
    </>
  );
};

export default ButtonsUser;
